module.exports = __webpack_public_path__ + "img/THE-BIG-4-0.7cd5202b.png";